import * as __WEBPACK_EXTERNAL_MODULE__storage_useLocalStorage_js_b8bd60aa__ from "../storage/useLocalStorage.js";
function usePersistentTableState(tableId, initialState = {}) {
    const defaultState = {
        sorting: [],
        columnVisibility: {},
        pagination: {
            pageIndex: 0,
            pageSize: 50
        },
        globalFilter: '',
        columnFilters: [],
        columnOrder: [],
        rowSelection: {},
        ...initialState
    };
    const [tableState, setTableState] = (0, __WEBPACK_EXTERNAL_MODULE__storage_useLocalStorage_js_b8bd60aa__.useLocalStorage)(`ranks:${tableId}`, defaultState);
    const setters = {
        setSorting: (updater)=>{
            setTableState((prev)=>({
                    ...prev,
                    sorting: update(prev.sorting, updater)
                }));
        },
        setColumnVisibility: (updater)=>{
            setTableState((prev)=>({
                    ...prev,
                    columnVisibility: update(prev.columnVisibility, updater)
                }));
        },
        setPagination: (updater)=>{
            setTableState((prev)=>({
                    ...prev,
                    pagination: update(prev.pagination, updater)
                }));
        },
        setGlobalFilter: (updater)=>{
            setTableState((prev)=>({
                    ...prev,
                    globalFilter: update(prev.globalFilter, updater)
                }));
        },
        setColumnFilters: (updater)=>{
            setTableState((prev)=>({
                    ...prev,
                    columnFilters: update(prev.columnFilters, updater)
                }));
        },
        setColumnOrder: (updater)=>{
            setTableState((prev)=>({
                    ...prev,
                    columnOrder: update(prev.columnOrder, updater)
                }));
        },
        setRowSelection: (updater)=>{
            setTableState((prev)=>({
                    ...prev,
                    rowSelection: update(prev.rowSelection, updater)
                }));
        },
        resetState: ()=>{
            setTableState(defaultState);
            localStorage.removeItem(`ranks:table-state-${tableId}`);
        }
    };
    return [
        tableState,
        setters
    ];
}
function update(param, updater) {
    return 'function' == typeof updater ? updater(param) : updater;
}
export { usePersistentTableState };

//# sourceMappingURL=usePersistentTableState.js.map